import { useMemo } from 'react';
import utilitySvg from '../../../../Components/Assets/utility.svg';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { EventDataTargetsEnum } from '../../../Services/Logging/DataLayerDefinitions';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import IconMenuDropdown from '../../Form/Inputs/IconMenuDropdown';

export interface ITableDownloadProps {
    handleExportButtonClick: () => void;
    track: TrackingEvent;
}

const TableDownload = (props: ITableDownloadProps) => {
    const [translations] = useLanguage();

    const exportOptions = useMemo(
        () => [
            {
                value: 'value',
                label: translations.words.values,
            },
        ],
        [translations],
    );

    return (
        <IconMenuDropdown
            name={EventDataTargetsEnum.CoverageLevelsTable}
            iconButton={<img src={utilitySvg} alt="#" />}
            options={exportOptions}
            handleSelection={props.handleExportButtonClick}
            tooltip={translations.actions.clickToDownload}
            track={{
                eventCategory: props.track.eventCategory,
                eventAction: `${props.track.eventAction}DownloadOptions`,
            }}
        />
    );
};

export default TableDownload;
